import { useTranslation } from 'react-i18next'
import { Box, Grid } from '@mui/material'
import { useField } from 'formik'
import InputField from 'components/atoms/fields/InputField'
import SliderField from 'components/atoms/fields/SliderField'
import { ISyllabusComponent } from 'types'

const SyllabusComponentList = ({ fieldProps, disabled }) => {
  
  const { t } = useTranslation()
  const [field] = useField<ISyllabusComponent[]>(fieldProps.name)

  return (
    <>
      { 
        field.value.map((value: ISyllabusComponent, index: number) => ( 
                
          <Box 
            className={'transparent-background'}
            key={ index }
            sx={{
              padding: '1rem',
            }}>
            <Grid
              container
              spacing={4}
              sx={{ alignItems: 'center' }}
            >
              <Grid item xs={12} lg={6}>
                <InputField
                  valueSelector='title'
                  fieldProps={{
                    label: t('common.title'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={6} lg={6}>
                <SliderField
                  valueSelector='importance'
                  fieldProps={{
                    label: t('common.importance'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  disabled={disabled}
                  min={0}
                  max={100}
                  step={5}
                  
                />
              </Grid>
            </Grid>
          </Box>
        ))
      }
    </>
  )

}
export default SyllabusComponentList


